export class EPF {
    constructor(_amount?: number, _customerId?: number, _date?: Date, _hasIAccount?: boolean, _iAccountPassword?: string, _iAccountUsername?: string, _remark?: string)
    constructor(private _amount: number, private _customerId: number, private _date: Date, private _hasIAccount: boolean, private _iAccountPassword: string, private _iAccountUsername: string, private _remark: string)
    { }

    set Amount(amount: number) { this._amount = amount }
    get Amount(): number { return this._amount }

    set CustomerId(customerId: number) { this._customerId = customerId }
    get CustomerId(): number { return this._customerId }

    set Date(date: Date) { this._date = date }
    get Date(): Date { return this._date }

    set HasIAccount(hasIAccount: boolean) { this._hasIAccount = hasIAccount }
    get HasIAccount(): boolean { return this._hasIAccount }

    set IAccountPassword(iAccountPassword: string) { this._iAccountPassword = iAccountPassword }
    get IAccountPassword(): string { return this._iAccountPassword }

    set IAccountUsername(iAccountUsername: string) { this._iAccountUsername = iAccountUsername }
    get IAccountUsername(): string { return this._iAccountUsername }

    set Remark(remark: string) { this._remark = remark }
    get Remark(): string { return this._remark }

    toUpdate() {
        const epf = new EPF();
        epf.HasIAccount = this._hasIAccount;
        epf.IAccountUsername = this._iAccountUsername;
        epf.IAccountPassword = this._iAccountPassword;
        epf.Remark = this._remark;
        return epf;
    }

    equals(epf: EPF): boolean {
        for (const key of Object.keys(epf)) {
            if (this[key] !== epf[key]) {
                return false; // Early termination
            }
        }
        return true;
    }
}

export interface IAPIEPF {
    date: string,
    amount: number,
    hasIAccount: boolean,
    iAccountUsername: string,
    iAccountPassword: string,
    remark: string
}

export interface EPFHistory {
    CustomerId: number,
    Id: number,
    ModifiedBy: string,
    ModifiedOn: Date,
    NewValue: EPF,
    OldValue: EPF
}